import { render, staticRenderFns } from "./MyForm.vue?vue&type=template&id=0046512f&scoped=true&"
import script from "./MyForm.vue?vue&type=script&lang=ts&"
export * from "./MyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046512f",
  null
  
)

export default component.exports